import { FINANCIAL_COCKPIT_NAMESPACE } from '../../../../configs/translations'

export const TRANSLATION_KEYS = {
  overall: `${FINANCIAL_COCKPIT_NAMESPACE}-overall`,
  bu: `${FINANCIAL_COCKPIT_NAMESPACE}-overall-bu`,
  allMarkets: `${FINANCIAL_COCKPIT_NAMESPACE}-all-markets`,
}
